import { ResponseContext } from "../../../@api";

import { translationKeys } from "../../models/app-translation-keys";
import { IMiddelware } from "../../models/interfaces/middelware.interface";
import { GlobalErrorsStore } from "../../stores";

export class ServerInternalErrorHandlingMiddleware implements IMiddelware {
  public readonly unhandledHttpStatusCodes = [500];

  constructor(private readonly globalErrorsStore: GlobalErrorsStore) {}

  public async post(context: ResponseContext): Promise<void> {
    if (this.unhandledHttpStatusCodes.includes(context.response.status)) {
      this.setError();
    } else {
      this.resetError();
    }
  }

  public resetError() {
    this.globalErrorsStore.removeError(translationKeys.globalErrors.serverInternalError);
  }

  public setError() {
    this.globalErrorsStore.addErrorIfNotExists(translationKeys.globalErrors.serverInternalError);
  }
}
